import React, { useEffect } from 'react';
import './Services.scss';
import { servicesData } from '../../data/servicesData';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Services() {

  useEffect(() => {
      AOS.init({
        duration: 1000,
        once: true,
      });
    
    }, []);

    const handleMouseEnter = (e) => {
      e.currentTarget.classList.add('transition');
      e.currentTarget.setAttribute('data-aos', '');
    };

  return (
    <section id="services" className="section services-content">
      <h2 className="title">Mes Prestations</h2>
      <div className="services-container">
        {servicesData.map((service, index) => (
          <a data-aos="flip-right"
            key={index}
            className="service-card-link"
            href={'/' + service.link}
          >
            <div className="service-card" onMouseEnter={handleMouseEnter}>
              <div className="service-image">
                <img src={`/img/prestations/${service.image}`} alt={service.title} />
              </div>
              <div className="service-info">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
              <a href="/a-propos" className="custom-card-button">En savoir plus</a>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}

export default Services;